import { render, staticRenderFns } from "./olduser.vue?vue&type=template&id=7e6afd89&scoped=true&"
import script from "./olduser.vue?vue&type=script&lang=js&"
export * from "./olduser.vue?vue&type=script&lang=js&"
import style0 from "./olduser.vue?vue&type=style&index=0&id=7e6afd89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6afd89",
  null
  
)

export default component.exports